import { useTranslation } from 'react-i18next';
import { ArrowRightSmall } from '@peacecover/icon';
import type { FAN_STYLE_OPTIONS } from '../constants/fanStyle';

interface FanStyleOptionCardProps {
  option: (typeof FAN_STYLE_OPTIONS)[keyof typeof FAN_STYLE_OPTIONS][number];
  handleOptionClick: (
    option: (typeof FAN_STYLE_OPTIONS)[keyof typeof FAN_STYLE_OPTIONS][number]
  ) => void;
}

const FanStyleOptionCard = ({ option, handleOptionClick }: FanStyleOptionCardProps) => {
  const { t } = useTranslation();
  return (
    <button
      type="button"
      onClick={() => handleOptionClick(option)}
      className="bg-[linear-gradient(92deg,rgba(255,255,255,0.50)_31.85%,rgba(255,255,255,0.10)_102.92%)] dark:bg-[linear-gradient(90deg,#000_5.09%,rgba(0,0,0,0.10)_102.89%)] flex items-center justify-between rounded-[12px] w-full py-[16px] pl-[16px] pr-[20px] shadow-[0_0_3px_0_rgba(0,0,0,0.08),0_0_10px_0_rgba(0,0,0,0.08)] dark:shadow-[0_0_3px_0_rgba(0,0,0,0.90),0_0_10px_0_rgba(0,0,0,0.40)]"
    >
      <div className="flex flex-col items-start gap-[12px]">
        <div className="rounded-[1px] px-[2px] bg-text-main-lv1 dark:bg-pure-white w-fit">
          <p className="text-[14px] font-semibold leading-[17px] text-pure-white dark:text-pure-black">
            {t(`FanStyleOptions.${option}.label`)}
          </p>
        </div>
        <p className="text-[15px] font-medium leading-[18px] text-text-main-lv3 text-left">
          {t(`FanStyleOptions.${option}.description`)}
        </p>
      </div>
      <ArrowRightSmall size={20} className="text-text-main-lv3" />
    </button>
  );
};

export default FanStyleOptionCard;
